(() => {
  if (window.TerplaxInquiryEventsBound) return;
  window.TerplaxInquiryEventsBound = true;

  const loadPrivacy = () => {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) return;
    if (typeof window.Shopify?.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
  };

  const analyticsAllowed = () => {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    } catch {
      return false;
    }
  };

  const token = (value, fallback) => {
    const candidate = String(value || '').trim();
    return /^[a-zA-Z][a-zA-Z0-9_-]{0,79}$/.test(candidate) ? candidate : fallback;
  };

  loadPrivacy();

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const link = target?.closest('[data-terplax-event], a[href*="wa.me"], a[href^="mailto:"]');
    if (!link || !analyticsAllowed()) return;

    let channel = 'contact';
    const href = link.getAttribute('href') || '';
    try {
      const destination = new URL(href, window.location.origin);
      if (destination.hostname === 'wa.me') channel = 'whatsapp';
      else if (destination.protocol === 'mailto:') channel = 'email';
    } catch {
      channel = 'contact';
    }
    if (!link.dataset.terplaxEvent && channel === 'contact') return;

    const defaultEvent = channel === 'whatsapp' ? 'whatsapp_quote_click' : channel === 'email' ? 'email_quote_click' : 'contact_click';
    const proposedEvent = token(link.dataset.terplaxEvent, defaultEvent);
    const eventName = /^[a-zA-Z][a-zA-Z0-9_]{0,39}$/.test(proposedEvent) ? proposedEvent : defaultEvent;
    const parameters = {
      intent: token(link.dataset.terplaxIntent, 'quote'),
      lead_intent: token(link.dataset.terplaxIntent, 'quote'),
      placement: token(link.dataset.terplaxPlacement, 'contact_link'),
      page_path: window.location.pathname,
      page_location: window.location.origin + window.location.pathname,
      event_source: 'terplax_theme',
      transport_type: 'beacon'
    };

    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', eventName, parameters);
      } catch {}
      return;
    }

    if (typeof window.Shopify?.analytics?.publish === 'function') {
      try {
        const delivery = window.Shopify.analytics.publish('terplax:contact_click', {
          ...parameters,
          event_name: eventName
        });
        if (delivery && typeof delivery.catch === 'function') delivery.catch(() => {});
      } catch {}
    }
  }, { capture: true });
})();
